// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/1d38d8a8/" + chunkId + "." + __webpack_require__.h() + ".v1d38d8a8.js";
};